import { render, staticRenderFns } from "./Rectangle.vue?vue&type=template&id=1055c2a3"
import script from "./Rectangle.vue?vue&type=script&lang=js"
export * from "./Rectangle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports